import { DatePipe, AsyncPipe, NgClass, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationService, TaskCategoryService, ToastMessageService, WhatsappSenderConfigService } from '@fitness-force/api';
import { BreadcrumbComponent } from '@fitness-force/common/breadcrumb';
import { AutomationEventType } from '@fitness-force/enum';
import type { CampAction, CampaignById, EmailActionPayload, EmailTemplateMaster, EmailTemplateMasterResponse, ListTaskCategoryResponse, ListWhatsAppSenderConfigurationMasterResponse, ListWhatsAppTemplateMaster, SMSFromMasterResponse, SmsActionPayload, SmsTemplateMaster, SmsTemplateMasterResponse, TENANTSINTERFACE, TaskActionPayload, TaskCategoryResponse, WhatsAppTemplateMaster, WhatsappActionPayload } from '@fitness-force/models';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { DayAgoPipe, AngularQueryBuilderComponent } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TENANTS_INFO } from '@fitness-force/state';
import { CampaignService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { StaffStoreService } from '@fitness-force/api';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'fitness-force-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    OverlayModule,
    PopoverModule,
    SkeletonModule,
    TagModule,
    AvatarModule,
    StyleClassModule,
    ShortNamePipe,
    DateTimeFormatPipe,
    DayAgoPipe,
    BreadcrumbComponent,
    AngularQueryBuilderComponent,
    TranslateModule,
    ProgressBarModule,
    RouterModule,
    AsyncPipe,
    NgClass,
    TitleCasePipe
]
})

export class CampaignDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store);
  translate = inject(TranslateService);
  private cd = inject(ChangeDetectorRef);
  private toastMessageService = inject(ToastMessageService);
  private campaignService = inject(CampaignService);
  private notificationService = inject(NotificationService);
  private whatsappSenderConfigService = inject(WhatsappSenderConfigService);
  private taskCategoryService = inject(TaskCategoryService);
  private staffStoreService = inject(StaffStoreService);

  showActionGroup1: boolean = true;
  showSkeleton$ = new BehaviorSubject(true);
  getAccessTenantList$: Observable<any> = new Observable();
  tenantId = 0;
  tenant!: any;
  campaignId:number=0;
  campaign:CampaignById = {} as CampaignById;
  staffInfo:BehaviorSubject<any> = new BehaviorSubject<any>(null);
  emailActionPayload :EmailActionPayload ={} as EmailActionPayload;
  smsActionPayload :SmsActionPayload ={} as SmsActionPayload;
  whatsAppActionPayload :WhatsappActionPayload ={} as WhatsappActionPayload;
  taskActionPayload :TaskActionPayload ={} as TaskActionPayload;

  emailTemplateMasters = [] as EmailTemplateMaster[];
  smsTemplateMasters = [] as SmsTemplateMaster[];
  whatsappTemplateMasters= [] as WhatsAppTemplateMaster[]
  emailConfigMaster:any;
  smsConfigMaster:any;
  whatsappConfigMaster:any;

  showEmailData = new BehaviorSubject(false);
  showSmsData = new BehaviorSubject(false);
  showWhatsappData = new BehaviorSubject(false);
  showTask = new BehaviorSubject(false);
  campaAction :CampAction ={} as CampAction;
  // allStaffs: any = [];
  taskCategory$ = new BehaviorSubject<TaskCategoryResponse[]>([]);
  eventType = AutomationEventType.Campaign;
  sqlRule:any="";
  
  // Client Filter display
  clientFilterType: 'none' | 'include' | 'exclude' = 'none';
  clientFilterIds: number[] = [];

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.showSkeleton$.next(true);
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.tenant = tenant.selected_tenant;
        this.SetOnLoadData();
      }
    });
    // this.store.select(STAFF_STATE).subscribe((staffs: any) => {
    //   this.allStaffs = staffs.staffList;
    // });
  }

  SetOnLoadData(): void {
    this.route.params.subscribe((params) => {
      if (params['id'] != undefined && parseInt(params['id']) > 0) {
        this.campaignId = parseInt(params['id']);
        this.GetCampaignDetails();
      }
    });
  }

  GetCampaignDetails()
  {
    this.campaignService.GetCampaignById(this.tenantId,this.campaignId).subscribe({
      next: async (res:CampaignById) => {
        this.campaign= res;
        this.campaAction = this.campaign.camp_actions[0];
        this.setStaffDetails();
        if(!this.checkObjectEmpty(JSON.parse(this.campaign.camp_actions[0].email_action_payload)))
        {
          this.emailActionPayload = JSON.parse(this.campaign.camp_actions[0].email_action_payload);
          if(this.emailActionPayload)
          {
             this.getEmailTemplateMaster();
          }
          else{
            this.showEmailData.next(true);
          }
        }
        if(!this.checkObjectEmpty(JSON.parse(res.camp_actions[0].sms_action_payload)))
        {
          this.smsActionPayload = JSON.parse(res.camp_actions[0].sms_action_payload);
          if(this.smsActionPayload)
          {
             this.getSmsTemplateMaster();
          }
          else{
            this.showSmsData.next(true);
          }
        }
        if(!this.checkObjectEmpty(JSON.parse(this.campaign.camp_actions[0].whatsapp_action_payload)))
        {
          this.whatsAppActionPayload = JSON.parse(this.campaign.camp_actions[0].whatsapp_action_payload);
          if(this.whatsAppActionPayload && this.whatsAppActionPayload.whatsapp_template_master_uuid && this.whatsAppActionPayload.whatsapp_template_master_uuid != '')
          {
             this.getWhatsAppTemplateMaster();
          }
          else{
            this.showWhatsappData.next(true);
          }
        }
        if(!this.checkObjectEmpty(JSON.parse(this.campaign.camp_actions[0].task_action_payload)))
        {
          this.taskActionPayload = JSON.parse(this.campaign.camp_actions[0].task_action_payload);
          this.getTaskCategory(this.tenantId);
          this.showTask.next(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(this.campaign.camp_actions[0].source_data_extraction_rules)))
        {
           const ruleObj = JSON.parse(this.campaign.camp_actions[0].source_data_extraction_rules);
           if(ruleObj.rule)
           {
              if(ruleObj.rule.sql && ruleObj.rule.params)
              {
                this.sqlRule = ruleObj.rule.sql;
                const sqlQuery = ruleObj.rule.sql;
                const params = ruleObj.rule.params;

                // Replace placeholders in the SQL query with actual values
                const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match:any, paramName:any) => {
                    if (params[paramName] !== undefined) {
                        return params[paramName];
                    }
                    return match; // Return the placeholder unchanged if param not found
                });
                this.sqlRule= actualSqlQuery;
              }
            }
            
            // Parse client filter
            if(ruleObj.client_filter) {
              if(ruleObj.client_filter.include_client_ids && ruleObj.client_filter.include_client_ids.length > 0) {
                this.clientFilterType = 'include';
                this.clientFilterIds = ruleObj.client_filter.include_client_ids;
              } else if(ruleObj.client_filter.exclude_client_ids && ruleObj.client_filter.exclude_client_ids.length > 0) {
                this.clientFilterType = 'exclude';
                this.clientFilterIds = ruleObj.client_filter.exclude_client_ids;
              }
            }
        }
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
    });
  }

  checkObjectEmpty(obj: any): boolean {
    for (const i in obj) return false;
    return true;
  }

  getEmailTemplateMaster()
  {
    const forkArray = [
      this.notificationService.getEmailTemplates(this.tenantId),
      this.notificationService.getSendEmailFromList(this.tenantId)
    ];
    forkJoin(forkArray).subscribe({
      next: (res:any) => {
        const emailTemplates = res[0] as EmailTemplateMasterResponse;
        this.emailTemplateMasters = emailTemplates.items ? emailTemplates.items : [] as EmailTemplateMaster[];
        const emailConfi = res[1] as any;
        this.emailConfigMaster = emailConfi.items.find((o: any) => o.id == this.emailActionPayload.email_from_config_id);
        this.showEmailData.next(true);
        this.cd.detectChanges();
      },
      error: () => {
        this.emailTemplateMasters = [] as EmailTemplateMaster[];
        this.emailConfigMaster = null;
      },
    });
  }

  getSmsTemplateMaster()
  {
    const forkArray = [
      this.notificationService.getSmsTemplates(this.tenantId),
      this.notificationService.getSendSMSFromList(this.tenantId)
    ];
    forkJoin(forkArray).subscribe({
      next: (res:any) => {
        const smsTemplates = res[0] as SmsTemplateMasterResponse;
        this.smsTemplateMasters = smsTemplates.items ? smsTemplates.items : [] as SmsTemplateMaster[];
        const smsConfi = res[1] as SMSFromMasterResponse;
        this.smsConfigMaster = smsConfi.items.find(o => o.id == this.smsActionPayload.sms_sender_config_id);
        this.showSmsData.next(true);
        this.cd.detectChanges();
      },
      error: () => {
        this.smsTemplateMasters = [] as SmsTemplateMaster[];
        this.smsConfigMaster = null;
      },
    });
  }

  getWhatsAppTemplateMaster()
  {
    const forkArray = [
      this.notificationService.getWhatsappTemplates(this.tenantId),
      this.whatsappSenderConfigService.ListWhatsAppSenderConfig(this.tenantId)
    ];
    forkJoin(forkArray).subscribe({
      next: (res:any) => {
        const whatsappTemplates = res[0] as ListWhatsAppTemplateMaster;
        this.whatsappTemplateMasters = whatsappTemplates.items ? whatsappTemplates.items : [] as WhatsAppTemplateMaster[];
        const whatsAppConfi = res[1] as ListWhatsAppSenderConfigurationMasterResponse;
        this.whatsappConfigMaster = whatsAppConfi.items.find(o => o.id == this.whatsAppActionPayload.whatsapp_sender_config_id);
        this.showWhatsappData.next(true);
        this.cd.detectChanges();
      },
      error: () => {
        this.whatsappTemplateMasters = [] as WhatsAppTemplateMaster[];
        this.whatsappConfigMaster = null;
      },
    });
  }

  setStaffDetails()
  {
    // this.store.pipe(select(STAFF_STATE),
    //   map((loaded) => {
    //     return loaded.staffListAll.filter((value) => value.id == this.campaign.created_by);
    //   }),
    //   mergeMap((value) => value)
    // ).subscribe({
    //   next: (staff:any) => {
    //     this.staffInfo.next(staff);
    //   },
    // });
    this.staffStoreService.getStaffById(this.campaign.created_by).subscribe((staff) => {
      this.staffInfo.next(staff);
    });
  }

  getTaskCategory(tenantId: number): void {
    this.taskCategoryService
      .getTaskCategory(tenantId)
      .subscribe((data: ListTaskCategoryResponse) => {
        const odata = data.items.filter((o: TaskCategoryResponse) => {
          return String(o.status).toLowerCase() == 'active';
        });
        this.taskCategory$.next(odata);
      });
  }

  client2LetterName(name: string): string {
    if (name) {
      const nameArray = name.split(' ');
      const newNameArray = [];
      for (let i = 0; i < nameArray.length; i++) {
        if (newNameArray.length >= 2) break;

        if (nameArray[i]) {
          newNameArray.push(nameArray[i]);
        }
      }
      return newNameArray.join(' ');
    } else {
      return '';
    }
  }

  getStaffDetails(id: any) {
    const staff =  this.staffStoreService.getStaffById(id);
    return staff || null;
  }

  getCategoryDetails(categoryId:number)
  {
    return this.taskCategory$.value.find(o => o.id == categoryId)!;
  }

  get showSkeleton():boolean
  {
    return this.showSkeleton$.getValue();
  }

  timeout(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  isNotDefaultDate(date:any)
  {
    return date != '1970-01-01T00:00:00' && date != '0001-01-01T00:00:00';
  }

}

